import { useEffect } from 'react';
import { getEnvConfig } from '@/config';
import { Button, EmptyState } from '@chikara/ui';
import { useCardBatches } from '@/features/card/hooks/useCard/useCardBatches';
import { CardBatchesTable } from '@/features/card/components/CardBatchesTable/CardBatchesTable';
import dataNotFound from '@/features/card/assets/empty-list-icon.svg';
import styles from './CardBatchesView.module.css';
import { t } from '@/i18n';

export const CardBatchesView = () => {
    const { batches, pagination, fetchBatches } = useCardBatches();
    const { zendeskUrl } = getEnvConfig();

    useEffect(() => {
        fetchBatches(pagination.currentPage, pagination.itemsPerPage);
    }, [pagination.currentPage, pagination.itemsPerPage]);

    if (!batches || batches.length === 0) {
        return <EmptyState
            title={t('dashboard.card.emptyState.trackingTitle')}
            description={t('dashboard.card.emptyState.trackingDescription')}
            imgSrc={dataNotFound}
            buttonText={t('dashboard.card.actions.request')}
            buttonAction={() => window.open(zendeskUrl, '_blank', 'noopener,noreferrer')}
        />;
    }

    return (
        <div className={styles.content}>
            <div className={styles.buttonsRow}>
                <Button
                    variant="primary"
                    size="md"
                    onClick={() => window.open(zendeskUrl, '_blank', 'noopener,noreferrer')}
                >
                    {t('dashboard.card.actions.request')}
                </Button>
            </div>
            <CardBatchesTable data={batches} pagination={pagination} />
        </div>
    );
};
